export class Utils {
  static generateRandomId(startWithALetter = false) {
    const id = Math.random().toString(36).substring(2);
    if (startWithALetter) {
      return Utils.generateRandomString(1) + id;
    }
    return id;
  }

  static generateRandomString(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  }

  /**
   * update list to display in drop down
   * @param: list
   * @param: useValue
   */
  static updateValue(list, useValue?: boolean) {
    if (list && list.length > 0) {
      list.forEach((d) => {
        d.value = d.name.replace(/[^a-zA-Z0-9]/g, ' ');
        if (useValue) {
          d.code = d.value;
        } else {
          d.code = d.code;
        }
      });
    }
  }

  static keyParmToObj(keyParams): any {
    const params = new URLSearchParams(keyParams);

    const obj = {};

    params.forEach((value, key) => {
      obj[key] = value;
    });

    return obj;
  }

  static base64ToBlob(base64StrArray: Array<string>) {
    const contentType = Utils.getContentTypeFromBase64(base64StrArray[0]);
    // Encode the base64 strings into a PDF file
    const byteCharacters = [];
    base64StrArray.forEach((base64Str) => {
      const byteCharactersTemp = atob(base64Str);
      for (let i = 0; i < byteCharactersTemp.length; i++) {
        byteCharacters.push(byteCharactersTemp.charCodeAt(i));
      }
    });

    // Create a Blob from the PDF file
    const byteArray = new Uint8Array(byteCharacters);
    const blob = new Blob([byteArray], { type: contentType });
    return window.URL.createObjectURL(blob);
  }

  static downloadFile(url: string, fileName: string, openInNewTab = false) {
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    if (openInNewTab) {
      link.target = '_blank';
    }
    link.click();
  }

  static getContentTypeFromBase64(base64String: string): string {
    const matches = base64String.match(/^data:(.*);base64,/);
    if (matches && matches.length > 1) {
      return matches[1];
    }
    throw new Error('Invalid base64 string');
  }

  static getBase64StringWithoutContentType(base64String: string): string {
    const matches = base64String.match(/^data:(.*);base64,(.*)$/);
    if (matches && matches.length > 2) {
      return matches[2];
    }
    throw new Error('Invalid base64 string');
  }
}
